module.exports = __webpack_public_path__ + "static/media/volume_blue.2a11361c.svg";